var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkboxContainer",class:`color-${_vm.color} size-${_vm.size}`,on:{"click":function($event){return _vm.$emit('click', !_vm.checked)}}},[_c('input',{attrs:{"data-flag":_vm.dataFlag,"type":"checkbox"},domProps:{"checked":_vm.checked}})])
}
var staticRenderFns = []

export { render, staticRenderFns }